import React from 'react';

export interface Product {
	id: number;
	path: string;
	itemName: string;
	code: string;
	description: string;
	price: number;
	quantity: number;
}

interface AppContextType {
	state: any;
	dispatch: any;
}

const AppContext = React.createContext<AppContextType>({
	state: undefined,
	dispatch: undefined,
});

export default AppContext;
